import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardFooter,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Link,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import { renderImgFromAssets, goToBack } from "../common/UtilityHelper";
import AppHeader from "./AppHeader";
import ListView from "./ListView";
import auth from "./Security/Auth";
import { UIServerURL } from "./GlobalSettings";
import ShareContentMessage from "./ShareContentMessage";

class T1T2Products extends Component {
  constructor(props) {
    super(props);

    this.state = {
      srchObjVal: undefined,
      bPopUpListView: false,
      bIsShared: false,
      TxProdUrl: undefined,
    };

    this.handleProdClick = this.handleProdClick.bind(this);
    this.closeList = this.closeList.bind(this);
    this.OnLink = this.OnLink.bind(this);
    this._hideShareContentPopUp = this._hideShareContentPopUp.bind(this);
  }

  componentDidMount() {
    document.body.style.overflow = "hidden";
    console.log("---T");
    console.log(
      "Products Catalog should be in Props ",
      this.props.currentT1T2ProductData
    );
    if (
      !this.props.currentT1T2ProductData ||
      this.props.currentT1T2ProductData.MetaDataItems.length === 0
    ) {
      this.props.history.push("/home");
    }
  }

  closeList() {
    this.setState({ srchObjVal: undefined, bPopUpListView: false });
  }

  _hideShareContentPopUp() {
    this.setState({ TxL2Url: undefined, bIsShared: false });
  }

  OnLink(selectedTaxL1Name, selectedTaxL2Name, selectedProdName) {
    console.log(
      "Link btn clicked to create for Tax Level 1 deeplink URL - " +
        selectedTaxL1Name +
        " and Tax L2 " +
        selectedTaxL2Name
    );
    var lnk =
      UIServerURL +
      "?t1=" +
      encodeURIComponent(selectedTaxL1Name) +
      "&t2=" +
      encodeURIComponent(selectedTaxL2Name) +
      "&prod=" +
      encodeURIComponent(selectedProdName);
    this.setState({ TxProdUrl: lnk, bIsShared: true });
  }

  handleProdClick = (product) => {
    console.log("Product Clicked is ", product);

    if (product && product.Metadata_ID && product.Metadata_Name) {
      var srchObj = {
        MetadataID: product.Metadata_ID,
        MetadataType: "Products", //product.Metadata_Type,
        MetadataName: product.Metadata_Name,
        Is_Enabled: true,
      };
      this.setState({ srchObjVal: srchObj, bPopUpListView: true });
    }
  };

  _HPEOnBackClick = () => {
    goToBack(this.props.history);
  };

  onHpeClick = () => {
    this.props.history.push("/hpd");
  };

  onHomeClick = () => {
    this.props.history.push("/home");
  };

  render() {
    const { currentT1T2ProductData, currentTaxonomyL2Data } = this.props;

    if (
      currentT1T2ProductData === null ||
      currentT1T2ProductData === undefined
    ) {
      this.props.history.push("/home");
    }

    const { Taxonomy_Name } = currentT1T2ProductData
      ? currentT1T2ProductData
      : "No Data - Please go to Home";

    if (auth.getProdParam()) {
      console.log(
        " From T1T2Product - Product Param supplied is",
        auth.getProdParam()
      );
      var ProdPrm = auth.getProdParam();
      var T1T2Prod = currentT1T2ProductData.MetaDataItems.filter((prd) => {
        return prd.Metadata_Name === ProdPrm;
      });
      if (T1T2Prod && T1T2Prod.length > 0) {
        console.log("Total Products Data is", currentT1T2ProductData);
        console.log("Matched Product from Deeplink is", T1T2Prod[0]);
        auth.removeProdParam();
        this.handleProdClick(T1T2Prod[0]);
      }
    }

    var searchObjToBe = this.state.srchObjVal;
    var bPopUpListItems = this.state.bPopUpListView;

    var PrdLnkUrl = this.state.bIsShared ? this.state.TxProdUrl : null;
    var isTxDeepLink = this.state.bIsShared;

    return (
      <Box fill="vertical" align="stretch" justify="start">
        <Main
          //overflow="auto"
          overflow={{ vertical: "scroll" }}
          background={{ image: "url('')" }}
          flex
          align="stretch"
          justify="start"
          margin={{ bottom: "xlarge" }}
        >
          <AppHeader />
          <Box
            align="stretch"
            justify="center"
            flex="grow"
            background={{ color: "background-back" }}
            direction="row"
          >
            <Box
              align="stretch"
              justify="start"
              flex="shrink"
              pad={{ horizontal: "large", vertical: "xsmall", top: "xsmall" }}
              gap="xxsmall"
              basis="xlarge"
            >
              <Header
                align="start"
                direction="column"
                justify="start"
                gap="xxsmall"
                flex={false}
              >
                {bPopUpListItems && searchObjToBe && (
                  <ListView
                    srchObj={searchObjToBe}
                    srchVal={undefined}
                    hide={this.closeList}
                    calledby="From Product Catalog"
                  />
                )}
                <Box
                  align="stretch"
                  justify="start"
                  direction="column"
                  gap="xsmall"
                >
                  <Box align="center" justify="start" direction="row">
                    <Button
                      label="Home"
                      icon={<FormPrevious />}
                      gap="xsmall"
                      onClick={this.onHomeClick}
                    />
                    <Button
                      label="All demos"
                      icon={<FormPrevious />}
                      gap="xsmall"
                      onClick={this.onHpeClick}
                    />
                    <Button
                      label={
                        currentTaxonomyL2Data
                          ? currentTaxonomyL2Data.Taxonomy_Name
                          : ""
                      }
                      icon={<FormPrevious />}
                      gap="xsmall"
                      onClick={this._HPEOnBackClick}
                    />
                  </Box>
                  <Heading>{Taxonomy_Name}</Heading>
                </Box>
              </Header>
              <Header
                align="center"
                direction="row"
                flex={false}
                justify="start"
                gap="medium"
              >
                {/*                 <Box
                  align="center"
                  justify="center"
                  direction="row"
                  gap="small"
                >
                  <TextInput icon={<Search />} placeholder="Search content" />
                </Box> */}
              </Header>
              <Box align="stretch" justify="center" gap="small" pad="small">
                {isTxDeepLink && PrdLnkUrl && (
                  <ShareContentMessage
                    url={PrdLnkUrl}
                    hide={this._hideShareContentPopUp}
                  />
                )}
                <Grid columns={{ size: "flex", count: 4 }} gap="small">
                  {currentT1T2ProductData &&
                    currentT1T2ProductData.MetaDataItems &&
                    Array.isArray(currentT1T2ProductData.MetaDataItems) &&
                    currentT1T2ProductData.MetaDataItems.length &&
                    currentT1T2ProductData.MetaDataItems.map((dataObj) => {
                      return (
                        <Card
                          key={dataObj.Metadata_ID}
                          justify="start"
                          gap="small"
                          hoverIndicator
                          //onClick={(product) => this.handleProdClick(dataObj)}
                        >
                          <Box
                            align="start"
                            justify="start"
                            fill="horizontal"
                            //border={{ color: "brand", size: "medium" }}
                            // round="full"
                            background={{ color: "brand" }}
                            elevation="medium"
                            //animation={{ type: "jiggle", duration: 3000 }}
                            onClick={(product) => this.handleProdClick(dataObj)}
                          >
                            <CardHeader
                              align="left"
                              direction="row"
                              flex={false}
                              justify="between"
                              gap="medium"
                              pad="small"
                              height="xsmall"
                            >
                              <Heading margin="none" level="2" size="xsmall">
                                {dataObj.Metadata_Name}
                              </Heading>
                            </CardHeader>
                          </Box>
                          <CardBody pad="small">
                            {dataObj.Metadata_logo &&
                              renderImgFromAssets(dataObj.Metadata_logo)}
                            {console.log(
                              "**** Metadata_logo is ",
                              dataObj.Metadata_logo
                            )}
                          </CardBody>
                          <CardFooter pad="small">
                            <Box
                              align="start"
                              justify="start"
                              fill="horizontal"
                            >
                              <Button
                                icon={<Link color="brand" />}
                                hoverIndicator
                                tip={{
                                  dropProps: { align: { left: "right" } },
                                  content: "Copy Url to Clipboard",
                                }}
                                onClick={() =>
                                  this.OnLink(
                                    currentTaxonomyL2Data.Taxonomy_Name,
                                    Taxonomy_Name,
                                    dataObj.Metadata_Name
                                  )
                                }
                              />
                            </Box>
                            <Box align="end" justify="end" fill="horizontal">
                              <Box
                                align="center"
                                justify="center"
                                border={{ color: "brand", size: "medium" }}
                                round="full"
                                background={{ color: "brand" }}
                                elevation="small"
                                animation="pulse"
                              >
                                <Text color="white">
                                  {dataObj.Content_Count &&
                                  dataObj.Content_Count > 0
                                    ? dataObj.Content_Count
                                    : 0}
                                </Text>
                              </Box>
                            </Box>
                          </CardFooter>
                        </Card>
                      );
                    })}
                </Grid>
              </Box>
            </Box>
          </Box>
        </Main>
      </Box>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    currentTaxonomyL2Data: state.taxonomy.currentTaxonomyL2Data,
    currentT1T2ProductData: state.taxonomy.currentT1T2ProductData,
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return {};
// };

export default connect(mapStateToProps, null)(T1T2Products);
